// Changed All HTTP Tags to HTTPS
(function() {
    // Function to replace HTTP with HTTPS in a given URL
    const replaceHttpWithHttps = (url) => {
        return url.replace(/^http:\/\//gi, 'https://');
    };

    // Select all anchor tags and images
    const anchors = document.querySelectorAll('a, img');

    // Iterate through each element and update the href or src attributes
    anchors.forEach(anchor => {
        if (anchor.href) {
            anchor.href = replaceHttpWithHttps(anchor.href);
        }
        if (anchor.src) {
            anchor.src = replaceHttpWithHttps(anchor.src);
        }
    });

    // Additionally, check other attributes that may contain URLs
    const elementsWithUrls = document.querySelectorAll('[src], [href]');
    
    elementsWithUrls.forEach(element => {
        if (element.src) {
            element.src = replaceHttpWithHttps(element.src);
        }
        if (element.href) {
            element.href = replaceHttpWithHttps(element.href);
        }
    });

    console.log('All HTTP URLs have been updated to HTTPS.');
})();